import script from "./ImportarNotasForms.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportarNotasForms.vue?vue&type=script&setup=true&lang=js"

import "./ImportarNotasForms.vue?vue&type=style&index=0&id=8e692840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e692840"]])

export default __exports__